export const SignInModalName = 'signIn';
